import Vue from 'vue'
import Router from 'vue-router'

import './variants/v0-core/css/app.css'

Vue.use(Router)

let needsLogin = async (to, from, next) => {
  let API = require(/* webpackChunkName: "html" */ './variants/v0-core/api/api.js')
  if (API.LS.LoggedIn) {
    next()
  } else {
    next('/v0/auth')
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/v0'
    },
    {
      path: '/rocket',
      component: () => import('./variants/v0-core/graohics/Rocket.vue')
    },
    {
      path: '/landing/fb',
      async beforeEnter (to, from, next) {
        let API = await import(/* webpackChunkName: "html" */ './variants/v0-core/api/api.js')
        try {
          let ok = await API.facebookArrive()
          if (ok) {
            next(`/v0/dash`)
          } else {
            window.alert('Email is taken. Please Try Others.')
            next('/v0/auth')
          }
        } catch (e) {
          console.log(e)
          window.alert('Email is taken. Please Try Others.')
          next('/v0/auth')
        }
      }
    },
    {
      path: '/landing/twitter',
      async beforeEnter (to, from, next) {
        let API = await import(/* webpackChunkName: "html" */ './variants/v0-core/api/api.js')
        try {
          let ok = await API.twitterArrive()
          if (ok) {
            next(`/v0/dash`)
          } else {
            window.alert('Email is taken. Please Try Others.')
            next('/v0/auth')
          }
        } catch (e) {
          console.log(e)
          window.alert('Email is taken. Please Try Others.')
          next('/v0/auth')
        }
      }
    },
    {
      path: '/landing/google',
      async beforeEnter (to, from, next) {
        let API = await import(/* webpackChunkName: "html" */ './variants/v0-core/api/api.js')
        try {
          let ok = await API.googleArrive()
          if (ok) {
            next(`/v0/dash`)
          } else {
            window.alert('Email is taken. Please Try Others.')
            next('/v0/auth')
          }
        } catch (e) {
          console.log(e)
          window.alert('Email is taken. Please Try Others.')
          next('/v0/auth')
        }
      }
    },
    {
      path: '/palms',
      component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/Home.vue')
    },
    {
      path: '/v0',
      component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/AppContext.vue'),
      children: [
        {
          path: '',
          beforeEnter: (to, from, next) => {
            let API = require(/* webpackChunkName: "html" */ './variants/v0-core/api/api.js')
            if (API.LS.LoggedIn) {
              next('/v0/dash')
            } else {
              next('/v0/home')
            }
          }
        },
        {
          path: 'dash',
          beforeEnter: needsLogin,
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/Dash.vue')
        },
        {
          path: 'create-new',
          beforeEnter: needsLogin,
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/JaneCreateGame.vue')
        },
        {
          path: 'game-list',
          beforeEnter: needsLogin,
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/GameList.vue')
        },
        {
          path: 'tutorials',
          beforeEnter: needsLogin,
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/Tutorials.vue')
        },
        {
          path: 'reports',
          beforeEnter: needsLogin,
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/Reports.vue')
        },
        {
          path: 'home',
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/Home.vue')
        },
        {
          path: 'explore',
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/Explore.vue')
        },
        {
          path: 'game-editor/:gameID',
          beforeEnter: needsLogin,

          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/JaneGameEditor.vue')
        },
        {
          path: 'game-code',
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/PinPage.vue')
        },
        {
          path: 'my-games',
          beforeEnter: needsLogin,

          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/AllMyGames.vue')
        },
        {
          path: 'my-reports',
          beforeEnter: needsLogin,

          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/AllMyReports.vue')
        },
        {
          path: 'auth',
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/Auth.vue')
        },
        {
          path: 'play-game/:sessionID',
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages-game/GamePlay.vue')
        },
        {
          path: 'host-game/:sessionID',
          beforeEnter: needsLogin,

          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages-game/GameHost.vue')
        },
        {
          path: 'question-folder/:gameID/:folderID',
          beforeEnter: needsLogin,

          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/QuestionFolder.vue')
        },
        {
          path: 'question-editor/:gameID/:questionID',
          beforeEnter: needsLogin,

          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/QuestionEditor.vue')
        },
        {
          path: 'question-photos/:gameID/:folderID',
          beforeEnter: needsLogin,

          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/QuestionPhotos.vue')
        },
        {
          path: 'session-report/:sessionID',
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/SessionReport.vue')
        }
      ]
    },
    {
      path: '/go/:slug',
      async beforeEnter (to, from, next) {
        let API = await import('./variants/v0-core/api/api')
        let result = await API.getSlug({ slug: to.params.slug })
        if (result.length > 0) {
          next(`/v0/play/${result[0]._id}`)
        } else {
          next(`/v0`)
        }
      }
    },
    {
      path: '/:pin',
      component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/AppContext.vue'),
      children: [
        {
          path: '',
          component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/PinPage.vue')
        }
      ]
    }
    // {
    //   path: '/:slug',
    //   component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/AppContext.vue'),
    //   children: [
    //     {
    //       path: '',
    //       component: () => import(/* webpackChunkName: "html" */ './variants/v0-core/pages/Slug.vue')
    //     }
    //   ]
    // }
  ]
})
